import { useContext } from 'react';
import { Context } from '../context/context';

export const useFieldIdWhichWillBeUpdated = () => {
  const { state, dispatch } = useContext(Context);

  const setFieldIdWhichWillBeUpdated = (state) => {
    dispatch({ type: 'setFieldIdWhichWillBeUpdated', payload: state });
  };

  return [setFieldIdWhichWillBeUpdated, state];
};
